var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.data
    ? _c("div", [
        _c("div", { staticClass: "container" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "clearfix" }),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-sm" }),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-3 mark" }, [
              !_vm.message
                ? _c("div", [
                    _c("h1", {
                      domProps: {
                        innerHTML: _vm._s(_vm.data.error.errorHeader)
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "clearfix" }),
                    _vm._v(" "),
                    _c("p", {
                      domProps: { innerHTML: _vm._s(_vm.data.error.errorText) }
                    })
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.message
                ? _c("div", [
                    _c("div", { staticClass: "header-wrapper" }, [
                      _c("h1", {
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.data.error.errorRemittanceHeader
                          )
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "clearfix" }),
                    _vm._v(" "),
                    _c("p", [_vm._v(_vm._s(_vm.remittanceError))]),
                    _vm._v(" "),
                    _c("p", {
                      domProps: {
                        innerHTML: _vm._s(_vm.data.error.errorRemittanceText)
                      }
                    })
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "clearfix" }),
              _vm._v(" "),
              _c("button", {
                staticClass: "btn btn-link--ext btn-lg btn-block",
                domProps: { innerHTML: _vm._s(_vm.data.error.toStartBtn) },
                on: {
                  click: function($event) {
                    return _vm.$router.push("/")
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-sm" })
          ]),
          _vm._v(" "),
          _vm._m(1)
        ])
      ])
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-sm" }),
      _vm._v(" "),
      _c("div", { staticClass: "col-sm" }),
      _vm._v(" "),
      _c("div", { staticClass: "col-sm" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-sm" }),
      _vm._v(" "),
      _c("div", { staticClass: "col-sm" }),
      _vm._v(" "),
      _c("div", { staticClass: "col-sm" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-026a7a08", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-026a7a08","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Error.vue
// module id = null
// module chunks = 